var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Translate } from "../../../../../I18N";
import { useAtomValue } from 'jotai';
import { uploadProgressAtom } from "./uploadProgressAtom";





const UploadProgress = ({ queueLength }) => {
  const { filename, progress } = useAtomValue(uploadProgressAtom);

  return filename ? /*#__PURE__*/
  _jsx("div", { className: "flex grow" }, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "Uploading"), "...\xA0", /*#__PURE__*/
  _jsx("span", { className: "font-semibold" }, void 0, filename), "\xA0",
  progress, "%\xA0", /*#__PURE__*/
  _jsx("span", { className: "flex flex-nowrap before:content-['('] after:content-[')']" }, void 0,
  queueLength + 1, "\xA0", /*#__PURE__*/
  _jsx(Translate, {}, void 0, "remaining files")
  )
  ) : /*#__PURE__*/

  _jsx("div", {});

};

export { UploadProgress };